import gql from 'graphql-tag';

export const USER_DELETE = gql`
    mutation userDelete ($id: ID!) {
        userDelete(id: $id) 
    }
`;

export default USER_DELETE;